export enum ENoviDashboardSider {
	DASHBOARD = 'Dashboard',
	CAMPAIGN_DASHBOARD = 'Campaign Dashboard',
	MY_CAMPAIGNS = 'My Campaigns',
	BRANDING = 'Branding',
	BYOT = 'BYOT',
	OUTBOUND_ANALYTICS = 'Outbound Analytics',
	LEADS = 'Leads',
	CONFIGURE = 'Configure',
	ANALYTICS = 'Analytics',
	VOICE_LIBRARY = 'Voice Library',
	TEXTING_AGENT = 'Texting Agent',
	CALL_LOGS = 'Call Logs',
	LOGS = 'Logs',
	ALL_LOGS = 'Inbox',
	INTAKE_FORMS = 'Intake Forms',
	TEXT_LOGS = 'Text Logs',
	VOICE_MAIL_LOGS = 'Voicemail Logs',
	REFERRAL_PROGRAM = 'Referral Program',
	TWO_WAY_TEXTING = '2-Way Texting',
	CRM = 'CRM',
	SCHEDULE = 'Campaign Schedule',
	TEXT_CAMPAIGNS = 'Text Campaigns',
	SUBSCRIPTION = 'Subscription',
	RESERVE_NUMBER = 'Reserve Number',
	CAMPAIGN_SETUP = 'CAMPAIGN SETUP',
	TEXT_CONFIGURATION = 'TEXT_CONFIGURATION',
	WEBHOOKS = 'WEBHOOKS',
	VARIABLES = 'VARIABLES',
	MANAGE_CREDITS = 'Manage Credits',
	NOTIFICATIONS = 'NOTIFICATIONS',
	EMAIL = 'EMAIL',
	CAMPAIGN_SETTINGS = 'CAMPAIGN SETTINGS',
}
